export const MISSING_OR_INVALID_TOKEN = "We're sorry but this survey has been closed and is no longer available."
export const ERROR_ON_SUBMISSION = "There was error in the submition please try again!"
export const THANKYOU_MESSAGE = {
    EN: 'Your response have been securely submitted.',
    FR: 'Votre réponse a été envoyée avec succès.',
    ES: 'Tu respuesta ha sido enviada con éxito.',
    POR: 'Sua resposta foi enviada com sucesso.'
}